/* Mobile drawer: drill-in submenus (one tap to a full list, no accordions).
   Works on the existing drawer markup; adds a Back bar + "View all" card to each
   top-level item that has children, and resets to the top level when the drawer closes. */
(function () {
  'use strict';

  function init() {
    var nav = document.querySelector('#NavDrawer .mobile-nav--main');
    if (!nav || nav.getAttribute('data-drill-ready')) return;
    nav.setAttribute('data-drill-ready', 'true');

    var drawer = document.getElementById('NavDrawer');
    var items = Array.prototype.slice.call(nav.children).filter(function (li) {
      return li.matches('li.mobile-nav__item.top-level') && li.querySelector(':scope > .mobile-nav__sublist');
    });

    items.forEach(function (li) {
      var head = li.querySelector(':scope > .mobile-nav__has-sublist');
      var sub = li.querySelector(':scope > .mobile-nav__sublist');
      var link = head && head.querySelector('.mobile-nav__link');
      if (!head || !sub || !link) return;
      var title = link.textContent.replace(/\s+/g, ' ').trim();

      li.classList.add('has-drill');

      var bar = document.createElement('li');
      bar.className = 'drill-bar';
      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'drill-back';
      back.textContent = 'Back';
      var h = document.createElement('p');
      h.className = 'drill-title';
      h.textContent = title;
      bar.appendChild(back);
      bar.appendChild(h);

      var all = document.createElement('li');
      all.className = 'mobile-nav__item drill-viewall';
      var a = document.createElement('a');
      a.className = 'mobile-nav__link';
      a.href = link.getAttribute('href');
      a.textContent = 'View all';
      all.appendChild(a);

      sub.insertBefore(all, sub.firstChild);
      sub.insertBefore(bar, sub.firstChild);
    });

    function reset() {
      nav.classList.remove('drill-open');
      Array.prototype.forEach.call(nav.querySelectorAll('.drill-active'), function (el) {
        el.classList.remove('drill-active');
      });
      if (drawer) drawer.scrollTop = 0;
    }

    function open(li) {
      reset();
      nav.classList.add('drill-open');
      li.classList.add('drill-active');
      if (drawer) drawer.scrollTop = 0;
      var b = li.querySelector('.drill-back');
      if (b) b.focus({ preventScroll: true });
    }

    // Capture phase: run before the theme's own accordion toggle handlers.
    nav.addEventListener('click', function (e) {
      var back = e.target.closest('.drill-back');
      if (back) {
        e.preventDefault();
        e.stopPropagation();
        var li = back.closest('li.has-drill');
        reset();
        var trigger = li && li.querySelector(':scope > .mobile-nav__has-sublist .mobile-nav__link');
        if (trigger) trigger.focus({ preventScroll: true });
        return;
      }
      var row = e.target.closest('li.has-drill > .mobile-nav__has-sublist');
      if (row) {
        e.preventDefault();
        e.stopPropagation();
        open(row.parentElement);
      }
    }, true);

    // Return to the top level whenever the drawer closes.
    new MutationObserver(function () {
      if (!document.body.classList.contains('js-drawer-open-left')) reset();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
